















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { GQL_vacationMoneyReport_vacationMoneyReport } from '@/queries/__generated__/vacationMoneyReport';
import { workRelationDisplay } from '@/app/WorkRelation';
import Decimal from '@/utils/decimal';
import sortBy from 'lodash/sortBy';
import formatAmount from '@/filters/formatAmount';

type Row = GQL_vacationMoneyReport_vacationMoneyReport;
type GroupKey = 'toPay' | 'overpaid' | 'notToPay';

interface IGroup {
  key: GroupKey;
  rows: Row[];
  sum: Decimal;
  explanation: string;
}

interface IThresholds {
  excludePositiveAmountsTo: Decimal;
  excludeNegativeAmountsTo: Decimal;
}

// Splits the report rows by what is left to pay after next year's payouts:
// above the positive threshold it still has to be paid, below the negative
// threshold too much has been paid out, and anything in between is ignored.
@Component
export default class LeftToPaySummary extends Vue {
  @Prop({ required: true }) private rows!: Row[];
  @Prop({ required: true }) private thresholds!: IThresholds;
  // Plain names and stacked full width tables for the PDF
  @Prop({ type: Boolean, default: false }) private print!: boolean;

  private workRelationDisplay = workRelationDisplay;

  private get groups(): IGroup[] {
    const positive = new Decimal(this.thresholds.excludePositiveAmountsTo);
    const negative = new Decimal(this.thresholds.excludeNegativeAmountsTo);

    const buckets: Record<GroupKey, Row[]> = { toPay: [], overpaid: [], notToPay: [] };

    for (const row of this.rows) {
      const left = new Decimal(row.leftToPayNextYearRealAmount);

      if (left.gt(positive)) buckets.toPay.push(row);
      else if (left.lt(negative)) buckets.overpaid.push(row);
      else buckets.notToPay.push(row);
    }

    const amounts = { positive: formatAmount(positive), negative: formatAmount(negative) };
    const explanations: Record<GroupKey, string> = {
      toPay: this.$t('PaycheckReport.VacationMoneyReport.Summary.toPayExplanation', { amount: amounts.positive }) as string,
      overpaid: this.$t('PaycheckReport.VacationMoneyReport.Summary.overpaidExplanation', { amount: amounts.negative }) as string,
      notToPay: this.$t('PaycheckReport.VacationMoneyReport.Summary.notToPayExplanation', amounts) as string,
    };

    return (Object.keys(buckets) as GroupKey[]).map(key => {
      const rows = sortBy(buckets[key], [ 'workRelation.employee.firstName', 'workRelation.employee.lastName' ]);
      return {
        key,
        rows,
        sum: rows.reduce((sum, row) => sum.add(row.leftToPayNextYearRealAmount), new Decimal(0)),
        explanation: explanations[key],
      };
    });
  }
}
